import { render, staticRenderFns } from "./BotWlcmHomeCampaignImagesCard.vue?vue&type=template&id=127f6f33"
import script from "./BotWlcmHomeCampaignImagesCard.vue?vue&type=script&lang=ts"
export * from "./BotWlcmHomeCampaignImagesCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports